import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";

import {AmplitudeAuthPlacement} from "../../tracking/amplitude/auth_amplitude_tracker";
import {AuthModalEntryClickSource} from "../types/auth_modal_entry_click_source";
import {AuthTabType} from "../utils/AuthTabType";

export interface AuthModalStore {
    isOpen: boolean;
    currentTab: AuthTabType;
    placement: AmplitudeAuthPlacement;
    entryAuthClickSource: AuthModalEntryClickSource | null;
}

export interface OpenAuthModalPayload {
    tab?: AuthTabType;
    placement?: AmplitudeAuthPlacement;
    entryAuthClickSource?: AuthModalEntryClickSource;
}

const initialState: AuthModalStore = {
    isOpen: false,
    currentTab: AuthTabType.REGISTRATION,
    placement: AmplitudeAuthPlacement.KM,
    entryAuthClickSource: null
};

export const authModalSlice = createSlice({
    name: "authModal",
    initialState,
    reducers: {
        openAuthModal: (state, action: PayloadAction<OpenAuthModalPayload | undefined>) => {
            const {tab, placement, entryAuthClickSource} = action.payload ?? {};

            return {
                ...state,
                isOpen: true,
                currentTab: tab ?? AuthTabType.REGISTRATION,
                placement: placement ?? AmplitudeAuthPlacement.KM,
                entryAuthClickSource: entryAuthClickSource ?? null
            };
        },
        setAuthModalTab: (state, action: PayloadAction<AuthModalStore["currentTab"]>) => {
            return {...state, currentTab: action.payload};
        },
        closeAuthModal: (state) => {
            state.isOpen = false;
            state.entryAuthClickSource = null;
        }
    }
});

export const {openAuthModal, setAuthModalTab, closeAuthModal} = authModalSlice.actions;
import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";

import {AmplitudeAuthPlacement} from "../../tracking/amplitude/auth_amplitude_tracker";
import {AuthModalEntryClickSource} from "../types/auth_modal_entry_click_source";
import {AuthTabType} from "../utils/AuthTabType";

export interface AuthModalStore {
    isOpen: boolean;
    currentTab: AuthTabType;
    placement: AmplitudeAuthPlacement;
    entryAuthClickSource: AuthModalEntryClickSource | null;
}

export interface OpenAuthModalPayload {
    tab?: AuthTabType;
    placement?: AmplitudeAuthPlacement;
    entryAuthClickSource?: AuthModalEntryClickSource;
}

const initialState: AuthModalStore = {
    isOpen: false,
    currentTab: AuthTabType.REGISTRATION,
    placement: AmplitudeAuthPlacement.KM,
    entryAuthClickSource: null
};

export const authModalSlice = createSlice({
    name: "authModal",
    initialState,
    reducers: {
        openAuthModal: (state, action: PayloadAction<OpenAuthModalPayload | undefined>) => {
            const {tab, placement, entryAuthClickSource} = action.payload ?? {};

            return {
                ...state,
                isOpen: true,
                currentTab: tab ?? AuthTabType.REGISTRATION,
                placement: placement ?? AmplitudeAuthPlacement.KM,
                entryAuthClickSource: entryAuthClickSource ?? null
            };
        },
        setAuthModalTab: (state, action: PayloadAction<AuthModalStore["currentTab"]>) => {
            return {...state, currentTab: action.payload};
        },
        closeAuthModal: (state) => {
            state.isOpen = false;
            state.entryAuthClickSource = null;
        }
    }
});

export const {openAuthModal, setAuthModalTab, closeAuthModal} = authModalSlice.actions;
